import { createContext, useContext } from 'react';

const PetDialogContext = createContext({});

export const PetDialogProvider = ({ children, ...props }) => {
  return <PetDialogContext.Provider value={{ ...props }}>{children}</PetDialogContext.Provider>;
};

export const usePetDialogContext = () => useContext(PetDialogContext);
